import { Controller } from "@hotwired/stimulus"

// Parallax blobs in the landing hero and scroll-reveal for sections (respects prefers-reduced-motion).
export default class extends Controller {
  static targets = ["reveal", "parallaxLayer", "stickyCta"]

  connect() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    this.setupStickyCta()

    if (this.reducedMotion) {
      this.revealTargets.forEach((el) => el.classList.add("is-visible"))
      return
    }

    this.playHeroVideo()

    this.revealTargets.forEach((el) => {
      const rect = el.getBoundingClientRect()
      const inView = rect.top < window.innerHeight * 1.05 && rect.bottom > -0.05 * window.innerHeight
      if (inView) el.classList.add("is-visible")
    })
    this.element.classList.add("landing-scroll--ready")

    this._onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this._onScroll, { passive: true })
    this.onScroll()

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible")
        })
      },
      { root: null, rootMargin: "0px 0px -6% 0px", threshold: 0.06 }
    )
    this.revealTargets.forEach((el) => this._observer.observe(el))
  }

  disconnect() {
    if (this._onScroll) window.removeEventListener("scroll", this._onScroll)
    if (this._observer) {
      this.revealTargets.forEach((el) => this._observer.unobserve(el))
      this._observer.disconnect()
    }
    if (this._stickyObserver) this._stickyObserver.disconnect()
    this.element.classList.remove("landing-scroll--ready")
  }

  onScroll() {
    const y = window.scrollY || window.pageYOffset
    this.parallaxLayerTargets.forEach((el) => {
      const speed = Number.parseFloat(el.dataset.parallaxSpeed || "0.1")
      const translate = y * speed
      el.style.transform = `translate3d(0, ${translate}px, 0)`
    })
  }

  playHeroVideo() {
    const video = this.element.querySelector("video.landing-hero-video")
    if (!video) return

    // На узких экранах и при экономии трафика видеофон не нужен:
    // он едва виден (opacity 0.32), но заметно бьёт по LCP и трафику.
    const narrow = window.matchMedia("(max-width: 768px)").matches
    const saveData = Boolean(navigator.connection && navigator.connection.saveData)
    if (narrow || saveData) {
      video.remove()
      return
    }

    video.play().catch(() => {})
  }

  // Плавающий CTA: показываем после прокрутки мимо hero и скрываем,
  // когда на экране финальный CTA (у него своя кнопка).
  setupStickyCta() {
    if (!this.hasStickyCtaTarget) return

    this.pastHero = false
    this.finalCtaVisible = false

    const hero = this.element.querySelector("section.landing-hero")
    const finalCta = this.element.querySelector("section.landing-final-cta")
    if (!hero && !finalCta) return

    this._stickyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (hero && entry.target === hero) this.pastHero = !entry.isIntersecting
          if (finalCta && entry.target === finalCta) this.finalCtaVisible = entry.isIntersecting
        })
        this.updateStickyCta()
      },
      { threshold: 0 }
    )

    if (hero) this._stickyObserver.observe(hero)
    if (finalCta) this._stickyObserver.observe(finalCta)
  }

  updateStickyCta() {
    if (!this.hasStickyCtaTarget) return
    this.stickyCtaTarget.classList.toggle("is-visible", this.pastHero && !this.finalCtaVisible)
  }
}
